<template>
<div>
  <h1>{{$t('download-annotations')}}</h1>
  <button class="button is-small is-fullwidth" @click="download()">
    <span class="icon"><i class="fas fa-download"></i></span>
    <span>{{$t('button-download')}}</span>
  </button>
</div>
</template>

<script>
export default {
  name: 'download-annotations',
  props: {
    index: String
  },
  computed: {
    imageWrapper() {
      return this.$store.getters['currentProject/currentViewer'].images[this.index];
    },
    image() {
      return this.imageWrapper.imageInstance.clone();
    },
    downloadUrl() {
      return `/images/${this.image.id}/annotations.zip`;
    }
  },
  methods: {
    async download() {
      window.open(this.downloadUrl);
    }
  }
};
</script>

<style scoped>
.buttons.is-fullwidth .button {
  flex: 1;
}
</style>
